var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.901,
    height: 29.47,
    viewBox: "0 0 25.901 29.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bin",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(32.796 8.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11789",
    "data-name": "Path 11789",
    d: "M62.205,150l1.529,18.461a2.6,2.6,0,0,0,2.58,2.375H80.4a2.6,2.6,0,0,0,2.58-2.375L84.514,150Zm6.837,17.383a.863.863,0,0,1-.861-.809l-.863-13.929a.863.863,0,0,1,.808-.916.85.85,0,0,1,.916.808l.863,13.929A.864.864,0,0,1,69.042,167.383Zm5.181-.863a.863.863,0,0,1-1.727,0V152.59a.863.863,0,1,1,1.727,0ZM79.4,152.644l-.863,13.929a.863.863,0,0,1-1.723-.108l.863-13.929a.877.877,0,0,1,.916-.808A.863.863,0,0,1,79.4,152.644Z",
    transform: "translate(-62.205 -150)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309",
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    d: "M55.175,3.454h-5.18V2.59A2.593,2.593,0,0,0,47.4,0H40.5a2.593,2.593,0,0,0-2.59,2.59v.863h-5.18a1.727,1.727,0,0,0,0,3.454H55.175a1.727,1.727,0,1,0,0-3.454Zm-6.907,0H39.634V2.59a.864.864,0,0,1,.863-.863H47.4a.864.864,0,0,1,.863.863Z",
    transform: "translate(-31)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin_icon.ac032ee098fee3f76a560a84d7b7a1bc.svg";
export { ForwardRef as ReactComponent };